var debounce = require('lodash/debounce');
const carouselVisibility = require('./utilities/carouselVisibility');
const BREAKPOINTS = {
    MD: 768  // Match Bootstrap $grid-breakpoints
};

// Use WeakMaps to store animation state and timeouts per carousel instance
const animatingEinsteinGroupMap = new WeakMap();
const einsteinGroupTimeoutsMap = new WeakMap();

// Use WeakMaps to store navigation direction and DOM order state per carousel instance
const slideNavDirectionMap = new WeakMap();
const domOrderChangedMap = new WeakMap();
const clickNavButtonMap = new WeakMap();

var isMobileScreenVisited = !window.matchMedia('(min-width: ' + BREAKPOINTS.MD + 'px)').matches;

/**
 * Get display information related to screen size
 * @param {jQuery} element - the current carousel that is being used
 * @returns {Object} an object with display information
 */
function screenSize(element) {
    var result = {
        itemsToDisplay: null,
        sufficientSlides: true
    };
    var viewSize = $(window).width();
    var extraSmallDisplay = element.data('xs');
    var smallDisplay = element.data('sm');
    var mediumDisplay = element.data('md');
    var numberOfSlides = element.data('number-of-slides');

    if (viewSize <= 575.98) {
        result.itemsToDisplay = extraSmallDisplay;
    } else if ((viewSize >= 576) && (viewSize <= 767.98)) {
        result.itemsToDisplay = smallDisplay;
    } else if (viewSize >= 768) {
        result.itemsToDisplay = mediumDisplay;
    }

    if (result.itemsToDisplay && numberOfSlides <= result.itemsToDisplay) {
        result.sufficientSlides = false;
    }

    return result;
}

/**
 * Makes the next element to be displayed next unreachable for screen readers and keyboard nav
 * @param {jQuery} element - the current carousel that is being used
 */
function hiddenSlides(element) {
    var carousel;

    if (element) {
        carousel = element;
    } else {
        carousel = $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel');
    }

    var screenSizeInfo = screenSize(carousel);

    var lastDisplayedElement;
    var elementToBeDisplayed;

    switch (screenSizeInfo.itemsToDisplay) {
        case 2:
            lastDisplayedElement = carousel.find('.active.carousel-item + .carousel-item');
            elementToBeDisplayed = carousel.find('.active.carousel-item + .carousel-item + .carousel-item');
            break;
        case 3:
            lastDisplayedElement = carousel.find('.active.carousel-item + .carousel-item + .carousel-item');
            elementToBeDisplayed = carousel.find('.active.carousel-item + .carousel-item + .carousel-item + .carousel-item');
            break;
        case 4:
            lastDisplayedElement = carousel.find('.active.carousel-item + .carousel-item + .carousel-item + .carousel-item');
            elementToBeDisplayed = carousel.find('.active.carousel-item + .carousel-item + .carousel-item + .carousel-item + .carousel-item');
            break;
        case 6:
            lastDisplayedElement = carousel.find('.active.carousel-item + .carousel-item + .carousel-item + .carousel-item + .carousel-item + .carousel-item');
            elementToBeDisplayed = carousel.find('.active.carousel-item + .carousel-item + .carousel-item + .carousel-item + .carousel-item + .carousel-item + .carousel-item');
            break;
        default:
            break;
    }

    carousel.find('.active.carousel-item').removeAttr('tabindex').removeAttr('aria-hidden');
    carousel.find('.active.carousel-item').find('a, button, details, input, textarea, select')
        .removeAttr('tabindex')
        .removeAttr('aria-hidden');

    if (lastDisplayedElement) {
        lastDisplayedElement.removeAttr('tabindex').removeAttr('aria-hidden');
        lastDisplayedElement.find('a, button, details, input, textarea, select')
            .removeAttr('tabindex')
            .removeAttr('aria-hidden');
    }

    if (elementToBeDisplayed) {
        elementToBeDisplayed.attr('tabindex', -1).attr('aria-hidden', true);
        elementToBeDisplayed.find('a, button, details, input, textarea, select')
            .attr('tabindex', -1)
            .attr('aria-hidden', true);
    }
}

/**
 * Aligns the previous and next carousel controls vertically based on the
 * height of the carousel inner container. This is applied only if the
 * `.pd-carousel-indicators` element exists within the specified Einstein carousel.
 *
 */
function setCarouselControlsAlignment() {
    const $carousel = $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel');
    const isDesktop = window.matchMedia(`(min-width: ${BREAKPOINTS.MD}px)`).matches;
    var isResizedFromMobileToDesktop = isDesktop && isMobileScreenVisited;

    if ($('.experience-einstein-carousel.marykay-einstein-carousel').find('.pd-carousel-indicators').length) {
        var carouselInnerHeight = $('.experience-einstein-carousel').find('.carousel-inner').outerHeight(true) || 0;
        var $carouselInner = $('.experience-einstein-carousel').find('.carousel-inner');
        var activeCarouselPosition = $('.experience-einstein-carousel').find('.active.carousel-item').data('position') || 0;
        $('.carousel-control-prev').attr('style', 'top: ' + (carouselInnerHeight / 2) + 'px !important');
        $('.carousel-control-next').attr('style', 'top: ' + (carouselInnerHeight / 2) + 'px !important');

        if (isDesktop && activeCarouselPosition >= 4) {
            $carouselInner.css('transform', 'translateX(-100%)');
        } else if (!isDesktop && activeCarouselPosition >= 4) {
            $carouselInner.css('transform', 'translateX(-200%)');
        }

        if (isResizedFromMobileToDesktop && activeCarouselPosition <= 2) {
            $carouselInner.css('transform', 'translateX(0)');
            isMobileScreenVisited = false;
            $carousel.carousel(0);
        }
    }
}

/**
 * Toggles visibility of carousel navigation controls based on the number of
 * items within each Einstein carousel instance. The controls are shown only
 * when the total number of `.carousel-item` elements exceeds the configured
 * items-per-slide count for the current viewport (xs or md breakpoint).
 * 
 * @function showCarouselControl
 * @returns {void}
 * 
 * @example
 * // If carousel has 6 items and md breakpoint shows 4 items:
 * // Controls WILL show (6 > 4)
 * 
 * // If carousel has 3 items and xs breakpoint shows 2 items:
 * // Controls WILL show (3 > 2)
 * 
 * // If carousel has 4 items and md breakpoint shows 4 items:
 * // Controls will NOT show (4 === 4, not greater than)
 */
function showCarouselControl() {
    var $recommendationTiles = $('.einstein-carousel');

    if ($recommendationTiles.length === 0) {
        return; // No carousels to process
    }

    $recommendationTiles.each(function () {
        carouselVisibility.updateCarouselControlVisibility($(this));
    });
}

$(document).ready(function () {
    // Store original DOM order for each carousel instance (only once, after full window load)
    const originalOrderMap = new WeakMap();
    var isDesktop = window.matchMedia(`(min-width: ${BREAKPOINTS.MD}px)`).matches;
    window.addEventListener('load', function() {
        $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel').each(function() {
            var $carousel = $(this);
            var $allItems = $carousel.find('.carousel-item');
            var $lastCarouselItem = $allItems.last();
            if (!$lastCarouselItem.hasClass('carousel-item-last')) {
                $lastCarouselItem.addClass('carousel-item-last');
            }
            if ($allItems.length > 0 && !originalOrderMap.has(this)) {
                var originalOrder = $allItems.map(function() { return this; }).get();
                originalOrderMap.set(this, originalOrder);
            }
        });
    });
    hiddenSlides();
    setCarouselControlsAlignment();

    $(window).on('resize', debounce(function () {
        var $carousels = $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel');
        isDesktop = window.matchMedia(`(min-width: ${BREAKPOINTS.MD}px)`).matches;
        hiddenSlides();
        setCarouselControlsAlignment();
        showCarouselControl();

        $carousels.each(function () {
            var $carousel = $(this);
            var originalOrderArr = originalOrderMap.get(this);
            var $allItems = $carousel.find('.carousel-item');
            var $carouselInner = $carousel.find('.carousel-inner');
            var $carouselActive = $allItems.filter('.active').first();
            var carouselActiveIdx = $carouselActive.index();

            var domOrderChanged = domOrderChangedMap.get(this) || false;
            if (!isDesktop && originalOrderArr && domOrderChanged) {
                $allItems.detach();
                for (var i = 0; i < originalOrderArr.length; i++) {
                    $carouselInner.append(originalOrderArr[i]);
                }
                domOrderChangedMap.set(this, false);
            }

            $carousel.find('.pd-carousel-indicators .active').removeClass('active');
            $carousel.find(".pd-carousel-indicators [data-position='" + carouselActiveIdx + "']").addClass('active');
        });

        isMobileScreenVisited = !isDesktop;
    }, 500));

    $('body').on('carousel:setup', function () {
        $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel').each(function() {
            var $carousel = $(this);
            var $allItems = $carousel.find('.carousel-item');
            var $lastCarouselItem = $allItems.last();
            if (!$lastCarouselItem.hasClass('carousel-item-last')) {
                $lastCarouselItem.addClass('carousel-item-last');
            }
            if ($allItems.length > 0 && !originalOrderMap.has(this)) {
                var originalOrder = $allItems.map(function() { return this; }).get();
                originalOrderMap.set(this, originalOrder);
            }
        });
        hiddenSlides();
        setCarouselControlsAlignment();
    });

    $('.carousel-control-prev[data-direction], .carousel-control-next[data-direction]').on('click', function (event) {
        event.preventDefault();
        var $carousel = $(this).closest('.carousel');
        var direction = $(this).data('direction');
        clickNavButtonMap.set($carousel[0], true);
        slideNavDirectionMap.set($carousel[0], direction);
    });

    $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel').on('touchstart', function (touchStartEvent) {
        var screenSizeInfo = screenSize($(this));

        if (screenSizeInfo.sufficientSlides) {
            var xClick = touchStartEvent.originalEvent.touches[0].pageX;
            $(this).one('touchmove', function (touchMoveEvent) {
                var xMove = touchMoveEvent.originalEvent.touches[0].pageX;
                if (Math.floor(xClick - xMove) > 5) {
                    $(this).carousel('next');
                } else if (Math.floor(xClick - xMove) < -5) {
                    $(this).carousel('prev');
                }
            });
            $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel').on('touchend', function () {
                $(this).off('touchmove');
            });
        }
    });

    $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel').on('slide.bs.carousel', function (e) {
        var $carousel = $(this);
        const displayControls = {
            xs: $carousel.data('xs') || 2,
            md: $carousel.data('md') || 4
        };

        isDesktop = window.matchMedia(`(min-width: ${BREAKPOINTS.MD}px)`).matches;

        // Get or initialize per-carousel state
        let animatingEinsteinGroup = animatingEinsteinGroupMap.get(this) || false;
        let einsteinGroupTimeouts = einsteinGroupTimeoutsMap.get(this) || { main: null, cleanup: null, fallback: null };

        // Per-carousel direction/order state
        let slideNavDirection = slideNavDirectionMap.get(this);
        // let domOrderChanged = domOrderChangedMap.get(this) || false;
        let clickNavButton = clickNavButtonMap.get(this) || false;

        if (animatingEinsteinGroup) {
            // Disable controls for visual feedback during animation, but allow carousel to finish its internal state change
            $carousel.find('.carousel-control-prev, .carousel-control-next').attr('disabled', true).addClass('disabled');
            return;
        }

        var screenInfo = isDesktop ? displayControls.md : displayControls.xs;
        var groupSize = screenInfo || 1;
        var $allItems = $carousel.find('.carousel-item');
        var carouselInner = $carousel.find('.carousel-inner');
        var totalItems = $allItems.length;
        var relatedIdx = $(e.relatedTarget).index();
        var activeIdx = $allItems.filter('.active').first().index();

        // Calculate the number of groups
        var numGroups = Math.ceil(totalItems / groupSize);

        // Find the group index for the relatedIdx
        var groupIdx = Math.floor(relatedIdx / groupSize);

        // Always align to group boundary: 0, groupSize, 2*groupSize, ...
        var newStartIdx = groupIdx * groupSize;

        // Clamp to valid range (ensure last group always starts at a group boundary)
        if (newStartIdx > (numGroups - 1) * groupSize) newStartIdx = (numGroups - 1) * groupSize;
        if (newStartIdx < 0) newStartIdx = 0;
        var $newGroup = $allItems.slice(newStartIdx, newStartIdx + groupSize);
        var $oldGroup = $allItems.slice(activeIdx, activeIdx + groupSize);

        // If already at this group, do nothing
        if ($oldGroup.first().index() === $newGroup.first().index()) return;

        // Clear any previous timeouts to prevent stacking
        if (einsteinGroupTimeouts.main) {
            clearTimeout(einsteinGroupTimeouts.main);
            einsteinGroupTimeouts.main = null;
        }
        if (einsteinGroupTimeouts.cleanup) {
            clearTimeout(einsteinGroupTimeouts.cleanup);
            einsteinGroupTimeouts.cleanup = null;
        }

        animatingEinsteinGroup = true;
        animatingEinsteinGroupMap.set(this, animatingEinsteinGroup);

        // Fallback: always reset animatingEinsteinGroup after 1 second to prevent stuck state
        if (einsteinGroupTimeouts.fallback) {
            clearTimeout(einsteinGroupTimeouts.fallback);
            einsteinGroupTimeouts.fallback = null;
        }
        einsteinGroupTimeouts.fallback = setTimeout(() => {
            animatingEinsteinGroup = false;
            animatingEinsteinGroupMap.set(this, animatingEinsteinGroup);
            einsteinGroupTimeouts.fallback = null;
            einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
        }, 1000);

        // Determine direction: 'left' means next, 'right' means prev
        var slideDirection = slideNavDirection !== undefined && slideNavDirection !== e.direction ? slideNavDirection : e.direction; // Fallback to event direction if slideNavDirection not set
        var isNext = slideDirection === 'left';
        var islooped = clickNavButton && ((isNext && activeIdx > newStartIdx) || (!isNext && activeIdx < newStartIdx));
        if (isNext) {
            einsteinGroupTimeouts.main = setTimeout(() => {
                if (islooped) {
                    $newGroup.appendTo(carouselInner);
                    carouselInner.removeAttr('style');
                    domOrderChangedMap.set(this, true);
                }
                // Calculate the translateX percentage based on group index and group size
                // For mobile: groupSize = 2, for desktop: groupSize = 4
                // groupIdx is the current group index (0-based)

                var translateX = -(groupIdx * 100);
                if (!islooped) {
                    carouselInner.css('transition-duration', '1500ms'); // Extend duration for non-looped transition to allow for smoother animation when jumping multiple groups
                    carouselInner.css('transform', 'translateX(' + translateX + '%)');
                }

                einsteinGroupTimeouts.cleanup = setTimeout(() => {
                    if (islooped) {
                        carouselInner.css('transition-duration', '1500ms');
                        carouselInner.css('transform', 'translateX(-100%)'); // Reset to show the newly appended group from the start
                    }
                    animatingEinsteinGroup = false;
                    animatingEinsteinGroupMap.set(this, animatingEinsteinGroup);
                    einsteinGroupTimeouts.main = null;
                    einsteinGroupTimeouts.cleanup = null;
                    if (einsteinGroupTimeouts.fallback) {
                        clearTimeout(einsteinGroupTimeouts.fallback);
                        einsteinGroupTimeouts.fallback = null;
                    }
                    einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
                }, 200);
                einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
            }, 800);
            einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
        } else {
            einsteinGroupTimeouts.main = setTimeout(() => {
                // For prev, calculate the group index and translateX
                var prevGroupIdx = groupIdx;
                var translateX = -(prevGroupIdx * 100);

                if (islooped) {
                    $newGroup.prependTo(carouselInner);
                    carouselInner.removeAttr('style'); // Remove any existing transform to reset position
                    carouselInner.css('transform', 'translateX(' + translateX + '%)');
                    domOrderChangedMap.set(this, true);
                }

                if (!islooped) {
                    carouselInner.css('transition-duration', '1500ms'); // Extend duration for non-looped transition to allow for smoother animation when jumping multiple groups
                    carouselInner.css('transform', 'translateX(' + translateX + '%)');
                }

                einsteinGroupTimeouts.cleanup = setTimeout(() => {
                    if (islooped) {
                        carouselInner.css('transition-duration', '1500ms');
                        carouselInner.css('transform', 'translateX(0%)'); // Reset to show the newly appended group from the start
                    }

                    animatingEinsteinGroup = false;
                    animatingEinsteinGroupMap.set(this, animatingEinsteinGroup);
                    einsteinGroupTimeouts.main = null;
                    einsteinGroupTimeouts.cleanup = null;
                    if (einsteinGroupTimeouts.fallback) {
                        clearTimeout(einsteinGroupTimeouts.fallback);
                        einsteinGroupTimeouts.fallback = null;
                    }
                    einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
                }, 200);
                einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
            }, 800);
            einsteinGroupTimeoutsMap.set(this, einsteinGroupTimeouts);
        }
        clickNavButtonMap.set(this, false);
    });

    $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel, .marykay-einstein-carousel .carousel').on('slid.bs.carousel', function () {
        var $carousel = $(this);
        hiddenSlides($carousel);

        // Dynamically update prev/next data-slide-to on each slide event
        var screenInfo = screenSize($carousel);
        var groupSize = screenInfo.itemsToDisplay || 1;
        var $allItems = $carousel.find('.carousel-item');
        var totalItems = $allItems.length;
        var numGroups = Math.ceil(totalItems / groupSize);
        var $active = $allItems.filter('.active').first();
        var activePosition = $active.data('position');
	    var activeIdx = (typeof activePosition === 'number' && !Number.isNaN(activePosition)) ? activePosition : $active.index();
        var currentGroupIdx = Math.floor(activeIdx / groupSize);

        // Calculate next/prev group start indices
        var nextGroupIdx = (currentGroupIdx + 1) % numGroups;
        var prevGroupIdx = (currentGroupIdx - 1 + numGroups) % numGroups;
        var nextStartIdx = nextGroupIdx * groupSize;
        var prevStartIdx = prevGroupIdx * groupSize;

        // Update indicators
        $carousel.find('.pd-carousel-indicators .active').removeClass('active');
        $carousel.find(".pd-carousel-indicators [data-position='" + activeIdx + "']").addClass('active');

        // Update controls
        $carousel.find('.carousel-control-next').attr('data-slide-to', nextStartIdx);
        $carousel.find('.carousel-control-prev').attr('data-slide-to', prevStartIdx);

        setTimeout(() => {
            var originalOrderArr = originalOrderMap.get($carousel[0]);
            var domOrderChanged = domOrderChangedMap.get($carousel[0]) || false;
            if (originalOrderArr && domOrderChanged) {
                var $carouselInner = $carousel.find('.carousel-inner');
                $allItems.detach();
                for (var i = 0; i < originalOrderArr.length; i++) {
                    $carouselInner.append(originalOrderArr[i]);
                }
                domOrderChangedMap.set($carousel[0], false);

                if(activeIdx >= groupSize) {
                    $carouselInner.css('transition-duration', '0ms');
                    $carouselInner.css('transform', 'translateX(-100%)');
                } else {
                    $carouselInner.removeAttr('style');
                }
            }
        }, 1820);
    });
});
